import type { AlertRecord } from '../api/useAllAlerts'
import type { AlertFilters } from './alertFilters'

export const applyAlertFilters = (alerts: AlertRecord[], filters: AlertFilters): AlertRecord[] => {
  return alerts.filter((alert) => {
    if (filters.titleTags.length > 0) {
      const titleLower = alert.title.toLowerCase()
      if (!filters.titleTags.some((tag) => titleLower.includes(tag.toLowerCase()))) {
        return false
      }
    }

    if (filters.contactTags.length > 0) {
      const allContacts = [...(alert.emails || []), ...(alert.phoneNumbers || [])]
      const contactsLower = allContacts.map((c) => c.toLowerCase())
      if (
        !filters.contactTags.some((tag) => contactsLower.some((c) => c.includes(tag.toLowerCase())))
      ) {
        return false
      }
    }

    if (filters.duration !== null) {
      const timeBuffer = alert.templateVariables?.timeBuffer
      if (timeBuffer === undefined || timeBuffer !== filters.duration) {
        return false
      }
    }

    if (filters.distance !== null) {
      const distance = alert.templateVariables?.distance
      if (distance === undefined || distance !== filters.distance) {
        return false
      }
    }

    if (!filters.showEnabled && alert.enabled) return false
    if (!filters.showDisabled && !alert.enabled) return false
    const hasContacts =
      (Array.isArray(alert.emails) && alert.emails.length > 0) ||
      (Array.isArray(alert.phoneNumbers) && alert.phoneNumbers.length > 0)
    if (!filters.showNoContacts && !hasContacts) return false

    return true
  })
}
